import {getDayName} from '@/library/date';
import {BREAK_BEGIN, BREAK_END, PATROL_BEGIN, WORK_BEGIN, WORK_END} from '@/library/modules/time-tracker/time-tracker';
import dateHelper from '@/utils/portuna/dateHelper';
import {type GetterTree} from 'vuex';

const getters: GetterTree<TimeTrackerState, RootState> = {
    currentButtonTooltip(state, getters)
    {
        return getters.isBreak ? 'Rückkehr von der Pause' : 'Arbeitsbeginn';
    },
    isLoggedIn(state, getters)
    {
        return getters.getState === WORK_BEGIN;
    },
    isBreak(state, getters)
    {
        return getters.getState === BREAK_BEGIN;
    },
    isLoggedOut(state, getters)
    {
        return getters.getState === WORK_END;
    },
    isOnPatrol(state)
    {
        return state.currentCircumstance === PATROL_BEGIN;
    },
    getState(state)
    {
        if ([WORK_BEGIN, BREAK_END].includes(state.currentState))
        {
            return WORK_BEGIN;
        }
        else if (state.currentState === BREAK_BEGIN)
        {
            return BREAK_BEGIN;
        }

        return WORK_END;
    },
    getStateString(state, getters)
    {
        let currentState = getters.getState;
        currentState     = getters.getState;
        if (currentState === WORK_BEGIN)
        {
            return 'Angemeldet';
        }
        else if (currentState === BREAK_BEGIN)
        {
            return 'Pause';
        }

        return 'Abgemeldet';
    },
    workTimeData(state, getters, rootState: RootState)
    {
        const data    = rootState.layoutData.time_tracker_data;
        const dayName = getDayName(<string>dateHelper('Y-m-d'));

        return data.work_days[dayName] ?? null;
    },
};

export default getters;